import { SERVER_URL } from '../../../helpers/Config';
import { history } from '../../../history';
import axios from 'axios';
import {
  setToken,
  removeToken,
  removePreviewToken,
} from '../../../helpers/Token';
import { toast } from 'react-toastify';
import { emitGAEvent } from '../../../helpers/GoogleAnalytics';
import { msConfig } from '../../../helpers/MicrosoftConfig';
import { PublicClientApplication } from '@azure/msal-browser';

export const changeRole = (role) => {
  return (dispatch) => dispatch({ type: 'CHANGE_ROLE', userRole: role });
};

export const logoutMS = async () => {
  const msObj = new PublicClientApplication({
    auth: {
      clientId: msConfig.appId,
      redirectUri: msConfig.redirectUri,
      authority: msConfig.authority,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true,
    },
  });

  let tokenResponse = await msObj.handleRedirectPromise();

  console.log('token on logout', tokenResponse);
  const config = {
    auth: {
      clientId: msConfig.appId,
      redirectUri: msConfig.redirectUri, // defaults to application start page
      postLogoutRedirectUri: msConfig.redirectUri,
    },
  };
  const myMsal = new PublicClientApplication(config);
  await myMsal.logoutPopup(config);
};

export const loginWithJWT = (user) => {
  return (dispatch) => {
    axios
      .post(SERVER_URL + 'persons/login', user)
      .then(async (response) => {
        let loggedInUser;

        if (response.data && response.data.isSuccess) {
          loggedInUser = response.data.data.token;
          await removePreviewToken();
          setToken(loggedInUser);

          dispatch({
            type: 'LOGIN_WITH_JWT',
            payload: { loggedInUser, loggedInWith: 'jwt' },
          });
          dispatch({
            type: 'TOAST',
            payload: {
              text: 'Welcome',
              type: 'success',
            },
          });
          const initialPath = window.initialPath || '/';
          history.replace(initialPath);
          const method = initialPath.includes('proposals')
            ? 'Proposal E-Mail Link'
            : initialPath.includes('projects')
            ? 'Project E-Mail Link'
            : 'Other';
          emitGAEvent('login', {
            method: method,
            initialPath: initialPath,
          });
        } else {
          dispatch({
            type: 'TOAST',
            payload: {
              text: 'Wrong e-mail or password',
              type: 'error',
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error('Wrong e-mail or password');
      });
  };
};

export const logoutWithJWT = () => {
  return (dispatch) => {
    dispatch({ type: 'LOGOUT_WITH_JWT', payload: {} });
    removeToken();
    removePreviewToken();
    window.initialPath = '/';
    history.push('/login');
  };
};
